export type FaqLanguage = 'en-us' | 'ar-ae';

export interface FaqTranslation {
  id: string;
  faq_id: string;
  language: FaqLanguage;
  question: string;
  answer: string;
  createdAt: string;
  updatedAt: string;
}

export interface FaqCategoryTranslation {
  id: string;
  faq_category_id: string;
  language: FaqLanguage;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface FaqCategory {
  id: string;
  is_active: boolean;
  createdAt: string;
  updatedAt: string;
  deleted_at: string | null;
  translations: FaqCategoryTranslation[];
}

export interface Faq {
  id: string;
  faq_category_id: string;
  position: number;
  is_active: boolean;
  createdAt: string;
  updatedAt: string;
  deleted_at: string | null;
  translations: FaqTranslation[];
  category: FaqCategory;
}

export interface FaqPagination {
  total: number;
  page: number;
  limit: number;
  total_pages: number;
}

export interface FaqListResponse {
  records: Faq[];
  pagination: FaqPagination;
}

export interface FaqCategoryListResponse {
  records: FaqCategory[];
  pagination: FaqPagination;
}

export interface PublicFaq {
  id: string;
  faq_category_id: string;
  position: number;
  is_active: boolean;
  createdAt: string;
  updatedAt: string;
  deleted_at: string | null;
  translations: FaqTranslation[];
}

export interface PublicFaqCategory extends FaqCategory {
  faqs: PublicFaq[];
}

export type PublicFaqListResponse = PublicFaqCategory[];